import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import sellerValidationSchema from '../../validations/SellerFormValidation';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import Link from '@mui/material/Link';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch } from "react-redux";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import Slider from "@madzadev/image-slider";
import "@madzadev/image-slider/dist/index.css";


function SellerBidListingForm() {

  React.useEffect(() => {
    // checkUserIsLogedIn()
    getEmpBidListing(initialValues)
  }, []);

  // const navigate = useNavigate();
  // const { auth_user } = useSelector((state) => state.authUser)
  // console.log('---SellerBidListingForm--auth_user:', auth_user)
  // const checkUserIsLogedIn = () => {
  //   if (!auth_user.is_logged_in) {
  //     navigate('/seller/request-otp-to-login')
  //   }
  // }

  const initialValues = {
    'search_in_field': '',
    'search_value_in_field': '',
    'order_by': 'updated_at',
    'order_type': 'desc',
    'page_no': 1,
  }
  const [reqPayload, setReqPayload] = React.useState(initialValues);
  const [paginationData, setPaginationData] = React.useState({});
  const [bids, setBids] = React.useState([]);
  const [listingFields, setListingFields] = React.useState([]);
  const dispatch = useDispatch();

  

  const [searchBy, setSearchBy] = React.useState('bid_by_emp__product_title');

  const handleSearchByChange = (event) => {
    setSearchBy(event.target.value);
  };

  const [orderBy, setOrderBy] = React.useState('updated_at');
  // console.log('----orderBy:', orderBy);

  const handleOrderByChange = (event) => {
    setOrderBy(event.target.value);
  };

  const [orderType, setOrderType] = React.useState('desc');
  // console.log('----orderType:', orderType);

  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
  };

  // const onSubmit = values => {
  // console.log('---onSubmit--values:', values);
  //   // getEmpBidListing(values);
  // }

  const handleFilterOnSubmit = values => {
    // console.log('---handleFilterOnSubmit---')
    // console.log('---handleFilterOnSubmit---values:', values)
    if (values['search_value_in_field']) {
      values[`${searchBy}`] = values['search_value_in_field'];
    }
    if (orderType == 'desc') {
      values['order_by'] = orderBy;
      values['order_type'] = orderType;
    } else {
      values['order_by'] = orderBy;
      values['order_type'] = '';
    }
    // console.log('---order-values:', values)
    getEmpBidListing(values);
  }

  const formik = useFormik({
    initialValues,
    onSubmit: handleFilterOnSubmit,
    // validate,
    validationSchema: sellerValidationSchema.sellerBidListingSchema,
    validateOnChange: false
  })

  // console.log('---formik--values:', formik.values);
  // console.log('---formik--errors:', formik.errors);

  const resetFormFilter = () => {
    formik.setValues(initialValues)
    getEmpBidListing(initialValues)
  }

  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    // authUtil.setCredentials('auth-token', response.data.data.auth_token)
    // dispatch(setSnackbar({
    //   status: 'success',
    //   message: response.data.message
    // }))
    setBids(response.data.data.dataset)
    setListingFields(response.data.data.listing_fields)
    setReqPayload(response.data.data.req_payload)
    setPaginationData(response.data.data.pagination)
  }

  const errorResponse = (error) => {
    formik.setErrors({ ...error.response.data.errors })
    // console.log('---errorResponse--formik--errors---221:', formik.errors);
  }

  const getEmpBidListing = async (data = {}, query = {}) => {
    try {
      // callApi.requestPOST(`${apiEndpoints.apiHost}/sellers-bids/emp/create-bid`, data, {}, successResponse, errorResponse)

      const response = await callApi.requestGET(`/sellers-bids/seller/bids-listing`, data, true)
      // console.log('---getEmpBidListing---response:', response);
      successResponse(response)
    }
    catch (error) {
      // console.log('---getEmpBidListing---error:', error);
      errorResponse(error)
    }
  }


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    overflow:'scroll',
    height:'80%',
    display:'block',
    bgcolor: 'background.paper',
    border: '2px solid black',
    boxShadow: 24,
    p: 4,
  };

  const [sellersRespondedBidDetail, setSellersRespondedBidDetail] = React.useState([]);

  const getEmpBidListing2 = async (data = {}, query = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/seller/bids-listing`, data, true)
      // console.log('---getEmpBidListing---response:', response);
      // successResponse(response)
      setSellersRespondedBidDetail(response.data.data.dataset)
    }
    catch (error) {
      // console.log('---getEmpBidListing---error:', error);
      errorResponse(error)
    }
  }

  const [openSellerBidDetailModal, setOpenSellerBidDetailModal] = React.useState(false);
  const handleSellerBidDetailModalOpen = (bid_by_emp_id) => {
    // console.log('---handleSellerBidDetailModalOpen--bid:', bid_id)
    getEmpBidListing2({ 'bid_by_emp': bid_by_emp_id, 'product_details': 1 })
    setOpenSellerBidDetailModal(true)
  };
  const handleSellerBidDetailModalClose = () => setOpenSellerBidDetailModal(false);


  return (
    <div>
      <div>

        <Box component="form" className="" onSubmit={formik.handleSubmit}>
          <div className='tw-grid mob:tw-grid-cols-2 desktop:tw-grid-cols-8 tw-gap-5'>

            <div className='tw-col-span-1'>
              <FormControl fullWidth>
                <InputLabel id="searchByLabel">Search By</InputLabel>
                <Select
                  labelId="searchByLabel"
                  id="searchById"
                  name="search_in_field"
                  value={searchBy}
                  label="Search By"
                  onChange={handleSearchByChange}
                  error={formik.errors.search_in_field ? true : false}
                >
                  {/* <MenuItem value={10}>Product Title</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem> */}
                  {listingFields.map((listingField) => (
                    <MenuItem key={listingField.key} value={listingField.key}>{listingField.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div className='tw-col-span-1'>
              <TextField id="outlined-basic" label="Search" name="search_value_in_field" onChange={formik.handleChange} value={formik.values.search_value_in_field} error={formik.errors.search_value_in_field ? true : false} helperText={formik.errors.search_value_in_field} variant="outlined" />
            </div>

            {/* <div className='tw-col-span-1'>
              <FormControl fullWidth>
                <InputLabel id="orderByLabel">Order By</InputLabel>
                <Select
                  labelId="orderByLabel"
                  id="orderById"
                  name="order_by"
                  value={orderBy}
                  label="Order By"
                  onChange={handleOrderByChange}
                  error={formik.errors.order_by ? true : false}
                >
                  {listingFields.map((listingField) => (
                    <MenuItem key={listingField.key} value={listingField.key}>{listingField.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div> */}

            {/* <div className='tw-col-span-1'>
              <FormControl fullWidth>
                <InputLabel id="orderTypeLabel">Order Type</InputLabel>
                <Select
                  labelId="orderTypeLabel"
                  id="orderTypeId"
                  name="order_type"
                  value={orderType}
                  label="Order Type"
                  onChange={handleOrderTypeChange}
                  error={formik.errors.order_type ? true : false}
                >
                  <MenuItem value={0}>Ascending</MenuItem>
                  <MenuItem value={'desc'}>Descending</MenuItem>
                </Select>
              </FormControl>
            </div> */}

            <div className='tw-col-span-1'>
              <TextField id="outlined-basic" label="Page No" type="number" name="page_no" onChange={formik.handleChange} value={formik.values.page_no} error={formik.errors.page_no ? true : false} helperText={formik.errors.page_no || `Total ${paginationData?.total_pages} Pages`} variant="outlined" />
            </div>

            <div className='mob:tw-col-span-1 desktop:tw-col-span-2 mob:tw-col-start-2 desktop:tw-col-start-7'>
              <Button className='tw-mx-0' variant="contained" size="small" onClick={resetFormFilter} >Reset</Button>
              <Button className='mob:tw-m-2 desktop:tw-mx-2' type="submit" variant="contained" size="small">Filter</Button>
            </div>

          </div>
        </Box>

        <div className='tw-mt-5 div-striped'>

          {/* <div className="mob:tw-hidden desktop:tw-block tw-mt-5"> */}
            <div xs={12} sm={12} className='tw-w-f tw-grid mob:tw-hidden desktop:flex desktop:tw-grid-cols-12 tw-gap-0 tw-border'>
              <span className='desktop:tw-col-span-2 tw-p-1 tw-border'>Product Title</span>
              <span className='desktop:tw-col-span-1 tw-p-1 tw-border'>Qty</span>
              <span className='desktop:tw-col-span-2 tw-p-1 tw-border'>Bid Price</span>
              <span className='desktop:tw-col-span-2 tw-p-1 tw-border'>Applied Price</span>
              <span className='desktop:tw-col-span-2 tw-p-1 tw-border'>Lowest Bid Till Now</span>
              {/* <span className='desktop:tw-col-span-1 tw-p-1 tw-border'>Product Expiry</span> */}
              <span className='desktop:tw-col-span-1 tw-p-1 tw-border'>Bid Valid Till</span>
              <span className='desktop:tw-col-span-1 tw-p-1 tw-border'>More Details</span>
              <span className='desktop:tw-col-span-1 tw-p-1 tw-border'>Action</span>
            </div>
          {/* </div> */}

          {bids.map((bid) => (
            // <li key={bid.id}>
            // <div className="tw-mt-2">
            <div key={bid.id} xs={12} sm={12} className='tw-w-f mob:tw-text-[12px] tw-grid mob:tw-grid-cols-8 desktop:tw-grid-cols-12 tw-gap-0 mob:tw-mt-2 desktop:tw-mt-0 tw-border'>
              <span className='mob:tw-col-span-4 mob:tw-row-span-2 desktop:tw-col-span-2 tw-p-1 mob:tw-text-[14px] b1sb'>{bid.product_title}</span>
              <span className='mob:tw-col-span-4 desktop:tw-col-span-1 tw-p-1 tw-flex b1sb'><span className='mob:tw-block desktop:tw-hidden tw-w-auto'>Qty:&nbsp;</span>{bid.quantity}</span>
              <span className='mob:tw-col-span-4 desktop:tw-col-span-2 tw-p-1 tw-flex b1sb'><span className='mob:tw-block desktop:tw-hidden tw-w-auto'>Bid Price:&nbsp;</span>{bid.emp_bid_price_label}</span>
              <span className='mob:tw-col-span-8 desktop:tw-col-span-2 tw-p-1 tw-flex b1sb'><span className='mob:tw-block desktop:tw-hidden tw-w-auto'>Applied Price:&nbsp;</span>{bid.bid_price_label}</span>
              <span className='mob:tw-col-span-8 desktop:tw-col-span-2 tw-p-1 tw-flex b1sb'><span className='mob:tw-block desktop:tw-hidden tw-w-auto'>Lowest Bid Till Now:&nbsp;</span>{bid.min_bid_by_other_seller}</span>
              {/* <span className='mob:tw-col-span-4 desktop:tw-col-span-1 tw-p-1 tw-flex b1sb'><span className='mob:tw-block desktop:tw-hidden'>Product Expiry:&nbsp;</span>{bid.product_expiry_type_name}</span> */}
              <span className='mob:tw-col-span-4 desktop:tw-col-span-1 tw-p-1 tw-flex b1sb'><span className='mob:tw-block desktop:tw-hidden'>Bid Valid Till:&nbsp;</span>{bid.bid_expiry}</span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-1 tw-p-1 b1sb'><Link onClick={() => handleSellerBidDetailModalOpen(bid.bid_by_emp)}>more info</Link></span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-1 tw-p-1 b1sb'>
                { bid.bid_is_expired ? null :
                <Link href={`/seller/response-on-bid/${bid.bid_by_emp}?form_action=update`} target='_blank'>Edit</Link>
                }
              </span>
            </div>
            // </div>
            // </li>
          ))}

        </div>

      </div>


      <Modal
        open={openSellerBidDetailModal}
        onClose={handleSellerBidDetailModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Seller Bid Details
          </Typography>
          <Link className='tw-absolute tw-top-5 tw-right-5' onClick={handleSellerBidDetailModalClose}><CloseIcon/></Link>
          <Typography id="modal-modal-description">
          </Typography>

          {sellersRespondedBidDetail.map((row) => (
            <div key={row.id} className='div-striped'>
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Product Title:</span> {row.product_title}</div>
              { row.product_details?.show_images?.length > 0 ? 
              <div className='tw-flex tw-p-5'>
                {/* <Slider imageList={images} width={300} height={300} showDotControls={false} /> */}
                <Slider imageList={row.product_details.show_images} width={300} height={300} showDotControls={false} />
              </div>
              : null
              }
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Quantity:</span> {row.quantity}</div>
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Price:</span> {row.bid_price_label}</div>
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Bid Valid Till:</span> {row.bid_expiry}</div>
              {/* <div className='tw-flex tw-p-5'><span className='tw-w-40'>Product Expiry:</span> {row.product_expiry_type_name}</div> */}
              {/* <div className='tw-flex tw-p-5'><span className='tw-w-40'>Created by:</span> {row.created_by}</div> */}
              {/* <div className='tw-flex tw-p-5'><span className='tw-w-40'>Created at:</span> {row.created_at}</div> */}
            </div>
          ))}

        </Box>
      </Modal>


      <Snackbar />
    </div>
  );

}


export { SellerBidListingForm };
